














































































































































/*
  getParam 获取评卷质量管理页面参数
  getMarkQualityMsg 获取评卷质量管理分页列表
  addMarkQualityMsg 添加评卷质量信息
  deleteMarkQualityMsg 删除评卷质量信息
*/
import { Vue, Component } from "vue-property-decorator";
//引入接口调用函数
import {
  getParam,
  getMarkQualityMsg,
  addMarkQualityMsg,
  deleteMarkQualityMsg
} from "../../../api/markingQualityManage";
//引入导入、导出、下载的处理函数
import importAndExportMixin from "../../../mixins/importAndExport";

@Component({
  name: "markingQualityManage",
  mixins: [importAndExportMixin],
  components: {
    UploadProgress: () => import("@/components/UploadProgress/index.vue"),
  },
})
export default class extends Vue {
  private projectId: string = ""; //项目
  private projectLabel: string = ""; //项目展示标签
  private teacherName: string = ""; //评卷教师姓名
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = []; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private total: number = 0; //总条数
  private chooseIdArray: string[] = []; //勾选的数据id集合
  private employState: string = ""; //聘用状态
  private chooseRowArray: object[] = []; //勾选的数据row 集合
  //页面参数
  private projects: object[] = []; //项目数组
  private tableHeight: number = 0;
  public $refs!: {
    table: HTMLFormElement;
  };
  private uploadData = {progressId: -1, projectId: this.projectId}; // 文件上传入参

  created() {
    //初始化data数据
    this.initDta();
    //获取页面参数
    this.getParams();
    //获取列表
    this.getData();
  }

  mounted() {
    setTimeout(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 80;
      if (this.tableHeight < 300) { this.tableHeight = 300; }
    }, 100);
  }

  initDta() {
    const { projectLabel, projectId } = this.$route.query;
    if (projectLabel && projectId) {
      this.projectId = projectId as string;
      this.projectLabel = projectLabel as string;
    }
  }

  //上传地址
  get uploadUrl() {
    return window.config.baseUrl4Shool + "/markteacher/markquality/upload";
  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  //获取页面参数
  private async getParams() {
    let res = await getParam();
    try {
      let res = await getParam();
      this.projects = res.data;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    let params = {
      current: this.pageNo, //当前页
      projectId: this.projectId, //项目id
      size: this.pageSize, //记录数
      teacherName: this.teacherName, //教师姓名
      employState: this.employState //聘用状态
    };
    try {
      let res = await getMarkQualityMsg(params);
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //搜索查询
  private searchHandle() {
    this.pageNo = 1;
    this.getData();
  }

  //勾选处理
  private selectChangeHandle(v: object[]) {
    this.chooseIdArray = v.map((item: any) => {
      return item.teacherId;
    });
    // 勾选的单行的内容 -- 用于打印优秀证书
    this.chooseRowArray = [...v];
  }

  //删除处理
  private deleteHandle() {
    // 之前流程
    // if (!this.projectId) {
    //   this.$message.warning("请选择项目！");
    //   return;
    // } else if (this.chooseIdArray.length <= 0) {
    //   this.$message.warning("请勾选！");
    //   return;
    // }

    // 现在流程
    if (this.chooseRowArray.length <= 0) {
      this.$message.warning("请先勾选！");
      return false;
    }
    //询问是否删除
    this.$confirm("确定删除?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      // 之前流程
      // let params = {
      //   ids: this.chooseIdArray,
      //   projectId: this.projectId
      // };

      // 现在流程
      let tempArr: Array<object> = [];
      this.chooseRowArray.forEach(v => {
        tempArr.push({
          projectId: v[`projectId`], //项目id
          teacherId: v[`teacherId`], //教师id
          subjectId: v[`subjectId`] //科目id
        });
      });
      try {
        await deleteMarkQualityMsg(tempArr);
        this.$message.success("删除成功");
        //操作成功，重新获取列表
        this.getData();
      } catch (error) {
        // this.$message.error(error || "删除失败");
        this[`$message`]({
          type: "error",
          message: error!.mesg ? error!.mesg : error
        });
      }
    });
  }

  //导出
  private exportHandle() {
    if (!this.projectId) {
      this.$message.warning("请选择项目！");
      return;
    }
    let params = {
      current: this.pageNo, //当前页
      projectId: this.projectId, //项目id
      size: this.pageSize, //记录数
      teacherName: this.teacherName //教师姓名
    };
    (this as any).downloadHandle("exportMarkQuality", "教师信息.xlsx", params);
  }

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
